import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const CartPage = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const [birthdayLeads, setBirthdayLeads] = useState([]);

    useEffect(() => {
        if (location.state?.birthdayLeads) {
            setBirthdayLeads(location.state.birthdayLeads); // 👈 Get passed data
            localStorage.setItem("cartItems", JSON.stringify(location.state.birthdayLeads)); // Save to localStorage
        } else {
            const storedLeads = localStorage.getItem("cartItems");
            if (storedLeads) {
                setBirthdayLeads(JSON.parse(storedLeads)); // Load from localStorage
            }
        }
    }, [location.state]);

    // Load bookings from localStorage
    useEffect(() => {
        const storedLeads = localStorage.getItem("cartItems");
        if (storedLeads) {
            setBirthdayLeads(JSON.parse(storedLeads));
        }
    }, []);

    // Handle Confirm Quotation
    const handleConfirmQuotation = () => {
        alert("Quotation request submitted!");

        // Clear localStorage and reset cart
        localStorage.removeItem("cartItems"); // or "birthdayLeads" based on what you're using
        setBirthdayLeads([]);

        // Navigate to test page
        navigate("/test");
    };

    return (
        <div className="min-h-screen bg-gray-100 flex flex-col items-center py-10">
            <div className="bg-white shadow-xl rounded-xl p-8 w-full max-w-4xl">
                <h2 className="text-2xl font-bold text-center mb-6 text-gray-800">
                    🛒 Your Booked Apartments
                </h2>

                {birthdayLeads.length === 0 ? (
                    <p className="text-center text-gray-500">
                        No booked apartments yet. Go back and add some!
                    </p>
                ) : (
                    <div className="space-y-4">
                        {birthdayLeads.map((item, index) => (
                            <div
                                key={index}
                                className="flex items-center border rounded-lg p-4 shadow-sm hover:shadow-md transition"
                            >
                                <img
                                    src={item.imageUrl || "https://via.placeholder.com/150"}
                                    alt={item.First_Name}
                                    className="w-24 h-24 object-cover rounded-lg mr-4"
                                />
                                <div className="flex-1">
                                    <h3 className="font-bold text-lg text-gray-800">
                                        {item.First_Name} {item.Last_Name}
                                    </h3>
                                    <p className="text-sm text-gray-500">{item.location ?? "Location unavailable"}</p>
                                    <p className="text-sm text-gray-600">
                                        Availability: {item.days ?? "Sun-Fri"} {item.time ?? "9:30 AM - 11 PM"}
                                    </p>
                                    <p className="text-sm font-semibold text-orange-600">
                                        Price: {item.price ?? "7 $/H"}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {birthdayLeads.length > 0 && (
                    <div className="text-center mt-6">
                        <button
                            onClick={handleConfirmQuotation}
                            className="bg-orange-500 hover:bg-orange-600 text-white font-semibold py-2 px-6 rounded-lg shadow-lg transition"
                        >
                            Confirm & Generate Quotation
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CartPage;
